__turbopack_context__.v({
  "container": "GVNEoG_container",
  "paymentMethod": "GVNEoG_paymentMethod",
  "showButton": "GVNEoG_showButton",
  "submitButtonBox": "GVNEoG_submitButtonBox",
});
